<h1>{{ 'shared.areYouStillThere' | translate }}</h1>
<p>{{ 'shared.logoutSessionAutomatically' | translate }}</p>
<button class="add-btn" id="e2e-tracking" (click)="continue()">{{ 'shared.yes' | translate }}</button>
